// Top-level navigation tabs.
// Keep ids in sync with the App.jsx switch + ENABLED_TABS env var.
// Each tab declares the permission required to see/use it. The frontend
// hides tabs the user can't view; the backend enforces the same on every
// route call (defense in depth).
import { Permission } from '../auth/roles.js';

export const APP_TABS = [
  { id: 'dashboard',  label: 'Dashboard',        requiredPermission: Permission.VIEW },
  { id: 'rules',      label: 'Rules',            requiredPermission: Permission.VIEW },
  { id: 'records',    label: 'Billing Records',  requiredPermission: Permission.VIEW },
  { id: 'extraction', label: 'Data Extraction',  requiredPermission: Permission.VIEW },
  { id: 'audit',      label: 'Audit Log',        requiredPermission: Permission.VIEW_AUDIT_LOG },
];

// A tab id IS its URL path segment — /records, /rules, /dashboard. Keeping
// them identical is what lets any link say "the page" without a lookup table
// on both sides; legacy paths that don't follow the rule are rewritten once
// at boot (see url/urlState.js).
export const APP_TAB_IDS = new Set(APP_TABS.map((t) => t.id));
